import _regeneratorRuntime from 'babel-runtime/regenerator';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React, { Component } from 'react';
import { HashRouter, Route, Switch, Router } from 'react-router-dom';
import API from '@aws-amplify/api';
import Auth from '@aws-amplify/auth';

import './App.css';
// Styles
// CoreUI Icons Set
import '@coreui/icons/css/coreui-icons.min.css';
// Import Flag Icons Set
import 'flag-icon-css/css/flag-icon.min.css';
// Import Font Awesome Icons Set
import 'font-awesome/css/font-awesome.min.css';
// Import Simple Line Icons Set
import 'simple-line-icons/css/simple-line-icons.css';
// Import Main styles for this application
import './scss/style.scss';

// Containers
import { DefaultLayout } from './containers';
import { PublicLayout } from './containers';
// Pages
// import {Login, Page404, Page500, Register} from './views/Pages';
// import {Page404, Page500, Register} from './views/Pages';

// import { renderRoutes } from 'react-router-config';
import { Login, LoginManager, loginStore as LoginManagerStore, LoginActions as LoginManagerActions, PrivateRoute } from '@radixnpm/rx-login';

// const Routes = require('./config/Configuration.json')
// const RoutesLoader = require('./config')
import { getRoutes, getPublicRoutes } from './routes';

var logdown = require('logdown');
var console = logdown('rx-dashboard', { prefixColor: '#00bcd4' });

var renderMergedProps = function renderMergedProps(component) {
  for (var _len = arguments.length, rest = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    rest[_key - 1] = arguments[_key];
  }

  var finalProps = Object.assign.apply(Object, [{}].concat(rest));

  return React.createElement(component, finalProps);
};

var PropsRoute = function PropsRoute(_ref) {
  var component = _ref.component,
      rest = _objectWithoutProperties(_ref, ['component']);

  return React.createElement(Route, _extends({}, rest, { render: function render(routeProps) {
      return renderMergedProps(component, routeProps, rest);
    } }));
};

import { createHashHistory as createHistory } from "history";

var storage = window.localStorage;

var PublicRoute = function (_Component) {
  _inherits(PublicRoute, _Component);

  function PublicRoute() {
    _classCallCheck(this, PublicRoute);

    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  PublicRoute.prototype.render = function render() {
    var _this2 = this;

    return React.createElement(Route, { render: function render(props) {
        return React.createElement(_this2.props.component, _this2.props);
      } });
  };

  return PublicRoute;
}(Component);

var App = function (_Component2) {
  _inherits(App, _Component2);

  function App(props) {
    var _this4 = this;

    _classCallCheck(this, App);

    var _this3 = _possibleConstructorReturn(this, _Component2.call(this, props));

    _this3.loginManager = new LoginManager();
    _this3.history = createHistory();
    //ADDED WEBHOOKS
    _this3.webhooksEndpoint = _this3.props.configuration.authentication.configuration.webhooksEndpoint ? _this3.props.configuration.authentication.configuration.webhooksEndpoint : null;

    console.log('##31 - before this.webhook Endpoint', _this3.webhooksEndpoint);
    if (_this3.webhooksEndpoint) {

      _this3.webhooks = _this3.props.configuration.authentication.configuration.webhooks ? _this3.props.configuration.authentication.configuration.webhooks : {};
      API.configure({
        endpoints: [{
          name: "LoginWebhook",
          endpoint: _this3.webhooksEndpoint,
          custom_header: function () {
            var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
              return _regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                  switch (_context.prev = _context.next) {
                    case 0:
                      _context.next = 2;
                      return Auth.currentSession();

                    case 2:
                      _context.t0 = _context.sent.idToken.jwtToken;
                      return _context.abrupt('return', {
                        Authorization: _context.t0
                      });

                    case 4:
                    case 'end':
                      return _context.stop();
                  }
                }
              }, _callee, _this4);
            }));

            return function custom_header() {
              return _ref2.apply(this, arguments);
            };
          }()
        }]
      });
      console.log('after configure LoginWebhook');
    }

    var configurationParams = {
      region: _this3.props.configuration.authentication.configuration.region,
      identityPoolId: _this3.props.configuration.authentication.configuration.identityPoolId,
      userPoolId: _this3.props.configuration.authentication.configuration.userPoolId,
      userPoolClientId: _this3.props.configuration.authentication.configuration.userPoolWebClientId
    };

    console.log('##32 before pubsub');
    if (_this3.props.configuration.authentication.configuration.pubsub) {
      console.log('##33 in pubsub');
      configurationParams.pubsub = true;
      configurationParams.pubsubEndpoint = _this3.props.configuration.authentication.configuration.pubsubEndpoint;
    }

    _this3.loginManager.configure(configurationParams);
    console.log('##34 after configure');
    var authenticated = false;

    console.log('try to load storage authenticated: ' + storage.authenticated);
    if (storage.authenticated == true || storage.authenticated == "true") {
      authenticated = true;

      //Event for resume session
      _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var data;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:

                console.log('3001d: in resume session');

                if (!_this3.props.events.onResumeLogin) {
                  _context2.next = 6;
                  break;
                }

                _context2.next = 4;
                return Auth.currentCredentials();

              case 4:
                data = _context2.sent;

                _this3.props.events.onResumeLogin(data);

              case 6:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this4);
      }))();
    }

    _this3.state = { authenticated: authenticated };

    var unsubscribe = LoginManagerStore.subscribe(_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      var state, credentials, _data, result, data;

      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              state = LoginManagerStore.getState();

              console.log('APP loginStore state: ' + JSON.stringify(state));

              _context3.next = 4;
              return Auth.currentCredentials();

            case 4:
              credentials = _context3.sent.identityId;

              console.log('credentials: ', credentials);

              _context3.t0 = state.state;
              _context3.next = _context3.t0 === LoginManagerActions.LOGIN_DONE ? 9 : _context3.t0 === LoginManagerActions.REFRESH_AUTH ? 24 : _context3.t0 === LoginManagerActions.EXPIRED ? 26 : _context3.t0 === LoginManagerActions.LOGOUT ? 26 : 30;
              break;

            case 9:

              console.log('in this.webhooks: ', _this3.webhooks);

              if (!(_this3.webhooks !== undefined && _this3.webhooks.onLogin !== undefined)) {
                _context3.next = 16;
                break;
              }

              _data = { // OPTIONAL
                body: { Identity: credentials }, // replace this with attributes you need
                headers: {} // OPTIONAL
              };
              _context3.next = 14;
              return API.post("LoginWebhook", _this3.webhooks.onLogin, _data);

            case 14:
              result = _context3.sent;

              console.log('in result with: ', result);

            case 16:
              _this3.setState({ authenticated: true });

              //Add login data to events
              // console.log(`3001: onLogin: `, this.props.events)
              // console.log(`3001b: onLogin: `, this.props.events.onLogin)

              if (!_this3.props.events.onLogin) {
                _context3.next = 22;
                break;
              }

              _context3.next = 20;
              return Auth.currentCredentials();

            case 20:
              data = _context3.sent;

              _this3.props.events.onLogin(data);

            case 22:

              //route to home
              _this3.history.push('/');

              return _context3.abrupt('break', 31);

            case 24:
              console.log('login done - change to authenticated: ' + storage.jwtToken);
              return _context3.abrupt('break', 31);

            case 26:
              console.log('in logout for set authenticated false');
              _this3.setState({ authenticated: false });
              storage.removeItem("authenticated");
              return _context3.abrupt('break', 31);

            case 30:
              return _context3.abrupt('break', 31);

            case 31:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this4);
    })));
    return _this3;
  }

  App.prototype.render = function render() {

    //check publicArea
    var hasPublic = this.props.configuration.publicArea != undefined && this.props.configuration.publicArea ? true : false;
    var publicRoutes = hasPublic ? getPublicRoutes(this.props.configuration, this.props.loaders, this.props.loading) : [];

    var routes = getRoutes(this.props.configuration, this.props.loaders, this.props.loading);
    // const routes = []
    return React.createElement(
      Router,
      { history: this.history },
      React.createElement(
        Switch,
        null,
        React.createElement(PropsRoute, { exact: true, path: '/login', name: 'Login Page', component: Login, loginTitle: this.props.configuration.authentication.configuration.loginTitle }),
        hasPublic && React.createElement(PublicRoute, { path: '/public/', name: 'Public', component: PublicLayout, logo: this.props.logo, logoMinimized: this.props.logoMinimized, routes: publicRoutes, managers: this.props.managers, dashboardConfiguration: this.props.configuration, layoutConfiguration: this.props.configuration.layoutConfiguration, defaultRoute: this.props.configuration.defaultPublicRoute }),
        React.createElement(PrivateRoute, { path: '/', name: 'Home', component: DefaultLayout, logo: this.props.logo, logoMinimized: this.props.logoMinimized, routes: routes, managers: this.props.managers, dashboardConfiguration: this.props.configuration, layoutConfiguration: this.props.configuration.layoutConfiguration, defaultRoute: this.props.configuration.defaultRoute, authenticated: this.state.authenticated, loginManager: this.loginManager })
      )
    );
  };

  return App;
}(Component);

App.defaultProps = {
  loaders: {},
  events: {},
  managers: {},
  logo: null,
  logoMinimized: null,
  loading: function loading() {
    return React.createElement(
      'div',
      null,
      'RX Loading...'
    );
  }
};

export default App;